import FieldsContainer from './RightSidebar';

export default FieldsContainer;